/**
 * Parse resource/notification-style `properties` that may arrive as:
 * - an already-decoded object
 * - a JSON string
 * - Base64 of a JSON UTF-8 payload (encoding/json []byte)
 */
export function parseJsonProperties(properties) {
  if (!properties) return {}
  if (typeof properties === 'object' && !Array.isArray(properties)) {
    return properties
  }
  if (typeof properties !== 'string') return {}

  try {
    const parsed = JSON.parse(properties)
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) return parsed
    if (typeof parsed === 'string') return parseJsonProperties(parsed)
  } catch {
    // Older / Go []byte responses may be Base64 instead of a JSON string.
  }

  try {
    const binary = typeof atob === 'function' ? atob(properties) : Buffer.from(properties, 'base64').toString('binary')
    const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0))
    const decoded = typeof TextDecoder !== 'undefined'
      ? new TextDecoder().decode(bytes)
      : Buffer.from(bytes).toString('utf8')
    return parseJsonProperties(decoded)
  } catch {
    return {}
  }
}

export function certificationExpiry(cert) {
  if (!cert) return ''
  const props = parseJsonProperties(cert.properties)
  return props.expiryDate || cert.expiry_date || ''
}
